module.exports = "/_next/static/images/ic_ticket-682edf61ea7e5871f3d5e102fb2dd7b6.png";